<div style="width: 100%; align-items: center">
  @if (loadingData) {
    <mat-progress-spinner mode="indeterminate" style="margin: 0 auto; margin-top: 20px"></mat-progress-spinner>
  }
</div>
<app-movement-no-purchase-details [data]="data"></app-movement-no-purchase-details>
